<template lang="pug">
.rich-text(v-html="content")
</template>
<script>
export default {
  name: 'RichText2',
  props: {
    content: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style lang="sass">
@import "src/styles/common.sass"
.rich-text
  width: 100%
  padding-bottom: pxToRem(100)
  blockquote
    padding-left: pxToRem(20)
    border-left: #DDDDDD 3px solid
    font-size: 16px
    color: #999999
    margin-block-start: 0
    margin-block-end: 0
    margin-inline-start: 0
    margin-inline-end: 0
    margin-bottom: pxToRem(40)
  h2
    font-size: 16px
    color: black
    margin-bottom: pxToRem(20)
  p
    font-size: 16px
    color: #999999
  img
    margin-top: pxToRem(40)
    width: 100%
</style>
